// ABOUTME: Measures the rendered bottom edge of the Crossing shell: the Steersman strip when shown, else the header.
// ABOUTME: Re-measures when the stage's children change or resize and on window resize; returns 0 outside a stage.

import { useLayoutEffect, useState } from 'react';

export function useShellBottom(): number {
  const [shellBottom, setShellBottom] = useState(0);

  useLayoutEffect(() => {
    // The sun lives in a different subtree from the header and strip, so the shell is found
    // by the stage attribute and the two test ids the frame already renders.
    const stage = document.querySelector('[data-crossing-stage]');
    if (!stage) return;

    const measure = () => {
      const shell = stage.querySelector('[data-testid="steersman-strip"]') ?? stage.querySelector('[data-testid="crossing-header"]');
      const bottom = shell ? shell.getBoundingClientRect().bottom : 0;
      setShellBottom((previous) => (previous === bottom ? previous : bottom));
    };

    // The strip's wrapping and the dev label's height move the bottom without any mutation,
    // so every current child of the stage is also watched for resizing.
    const resizeObserver = new ResizeObserver(measure);
    const observeChildren = () => {
      resizeObserver.disconnect();
      Array.from(stage.children).forEach((child) => resizeObserver.observe(child));
    };
    const mutationObserver = new MutationObserver(() => {
      observeChildren();
      measure();
    });

    measure();
    observeChildren();
    mutationObserver.observe(stage, { childList: true });
    window.addEventListener('resize', measure);
    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return shellBottom;
}
